import { render, staticRenderFns } from "./well-info.vue?vue&type=template&id=207b7be2"
import script from "./well-info.vue?vue&type=script&lang=js"
export * from "./well-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports